module.exports = __webpack_public_path__ + "img/ic_lock_nor.661444b5.svg";